var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExportWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hover/Action-Button/Export",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF00",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-calendar/Outlined",
    transform: "translate(1.875, 1.5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_edit",
    transform: "translate(3, 1.6429)",
    fill: "#b8b8ce",
    fillRule: "nonzero",
    opacity: 0.99,
    stroke: "#b8b8ce",
    strokeWidth: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.534757,7.89592968 C11.9913353,8.17487613 12.05,8.36333821 12.05,8.55594531 L12.05,11.299487 C12.05,11.8576681 11.8556286,12.3927739 11.5104253,12.7873903 C11.162879,13.1846851 10.6912989,13.4071429 10.2,13.4071429 L1.8,13.4071429 C1.30870108,13.4071429 0.837121297,13.1846851 0.489574949,12.7873903 C0.144371677,12.3927739 -0.05,11.8576681 -0.05,11.299487 L-0.05,8.55594531 C-0.05,8.36158037 0.0179433828,8.17539026 0.138103,8.03803074 C1.20307436,8.12053249 1.25,8.33863387 1.25,8.55594531 L1.25,11.299487 L10.1863646,11.9350489 C10.6784891,11.6310199 10.75,11.4710425 10.75,11.299487 L10.75,8.55594531 C10.75,8.36158037 10.817943,8.17539026 10.9381026,8.03803074 C11.2278408,7.93125771 11.4077009,7.89592968 11.534758,7.89592968 Z M5.43035353,0.162339117 C5.89996416,-0.0771867245 6.1163585,-0.0680129002 6.3117639,0.00928983424 L9.70552146,3.08978257 L6.8,2.44638682 L6.8,9.09877751 C6.8,9.29809202 6.71548574,9.48942259 6.5644504,9.63042406 C6.41474881,9.77018039 6.21177621,9.84895205 6,9.84895205 C5.78822379,9.84895205 5.58525119,9.77018039 5.4355496,9.63042406 C5.28451426,9.48942259 5.2,9.29809202 5.2,9.09877751 L5.2,2.4995273 L3.35799926,4.22666632 Z",
    id: "Vector"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExportWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Export-White.e5852fec9b20cd7b5b133caec69297ca.svg";